var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 19,
    width: 19,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Menu-2",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8 C26.418278,8 30,11.581722 30,16 L30,22 C30,26.418278 26.418278,30 22,30 L16,30 C11.581722,30 8,26.418278 8,22 L8,16 C8,11.581722 11.581722,8 16,8 L22,8 Z M22,13 L16,13 C14.4023191,13 13.0963391,14.24892 13.0050927,15.8237272 L13,16 L13,22 C13,23.5976809 14.24892,24.9036609 15.8237272,24.9949073 L16,25 L22,25 C23.5976809,25 24.9036609,23.75108 24.9949073,22.1762728 L25,22 L25,16 C25,14.4023191 23.75108,13.0963391 22.1762728,13.0050927 L22,13 Z",
    fill: "#fff",
    fillRule: "nonzero",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,8 C52.418278,8 56,11.581722 56,16 L56,22 C56,26.418278 52.418278,30 48,30 L42,30 C37.581722,30 34,26.418278 34,22 L34,16 C34,11.581722 37.581722,8 42,8 L48,8 Z M48,13 L42,13 C40.4023191,13 39.0963391,14.24892 39.0050927,15.8237272 L39,16 L39,22 C39,23.5976809 40.24892,24.9036609 41.8237272,24.9949073 L42,25 L48,25 C49.5976809,25 50.9036609,23.75108 50.9949073,22.1762728 L51,22 L51,16 C51,14.4023191 49.75108,13.0963391 48.1762728,13.0050927 L48,13 Z",
    fill: "#fff",
    fillRule: "nonzero",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,34 C26.418278,34 30,37.581722 30,42 L30,48 C30,52.418278 26.418278,56 22,56 L16,56 C11.581722,56 8,52.418278 8,48 L8,42 C8,37.581722 11.581722,34 16,34 L22,34 Z M22,39 L16,39 C14.4023191,39 13.0963391,40.24892 13.0050927,41.8237272 L13,42 L13,48 C13,49.5976809 14.24892,50.9036609 15.8237272,50.9949073 L16,51 L22,51 C23.5976809,51 24.9036609,49.75108 24.9949073,48.1762728 L25,48 L25,42 C25,40.4023191 23.75108,39.0963391 22.1762728,39.0050927 L22,39 Z",
    fill: "#fff",
    fillRule: "nonzero",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,34 C52.418278,34 56,37.581722 56,42 L56,48 C56,52.418278 52.418278,56 48,56 L42,56 C37.581722,56 34,52.418278 34,48 L34,42 C34,37.581722 37.581722,34 42,34 L48,34 Z M48,39 L42,39 C40.4023191,39 39.0963391,40.24892 39.0050927,41.8237272 L39,42 L39,48 C39,49.5976809 40.24892,50.9036609 41.8237272,50.9949073 L42,51 L48,51 C49.5976809,51 50.9036609,49.75108 50.9949073,48.1762728 L51,48 L51,42 C51,40.4023191 49.75108,39.0963391 48.1762728,39.0050927 L48,39 Z",
    fill: "#fff",
    fillRule: "nonzero",
    id: "Rectangle"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareMenu);
export default __webpack_public_path__ + "static/media/square-menu.b16d4c4d3afa0b20633112d54f1ea036.svg";
export { ForwardRef as ReactComponent };